"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var makeStyles_1 = __importDefault(require("@material-ui/core/styles/makeStyles"));
var Typography_1 = __importDefault(require("@material-ui/core/Typography"));
var classnames_1 = __importDefault(require("classnames"));
var Box_1 = __importDefault(require("@material-ui/core/Box"));
var InfoOutlined_1 = __importDefault(require("@material-ui/icons/InfoOutlined"));
var ErrorOutline_1 = __importDefault(require("@material-ui/icons/ErrorOutline"));
var ReportProblemOutlined_1 = __importDefault(require("@material-ui/icons/ReportProblemOutlined"));
var CheckCircleOutline_1 = __importDefault(require("@material-ui/icons/CheckCircleOutline"));
var utils_1 = require("./utils");
var theme_1 = require("../../theme");
var defaultBannerIcons = {
    info: InfoOutlined_1.default,
    error: ErrorOutline_1.default,
    warning: ReportProblemOutlined_1.default,
    success: CheckCircleOutline_1.default
};
var useStyles = makeStyles_1.default(function (theme) { return ({
    iconContainer: {
        color: theme.palette.primary.contrastText,
        width: theme.spacing(7),
        minHeight: theme.spacing(7),
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        flexShrink: 0
    },
    iconContainerInfo: {
        background: theme_1.colors.blue[300],
    },
    iconContainerError: {
        background: theme_1.colors.red[400]
    },
    iconContainerSuccess: {
        background: theme_1.colors.green[300],
    },
    iconContainerWarning: {
        background: theme_1.colors.yellow[300]
    },
    icon: {
        width: theme.spacing(3),
        height: theme.spacing(3)
    },
    messageContainer: {
        display: 'flex',
        alignItems: 'center',
        padding: theme.spacing(2),
    },
    root: {
        display: 'flex',
        justifyContent: 'flex-start',
        alignContent: 'center',
        borderWidth: 1,
        borderStyle: 'solid',
        backgroundColor: theme.palette.primary.contrastText
    },
    rootInfo: {
        borderColor: theme_1.colors.blue[300]
    },
    rootError: {
        borderColor: theme_1.colors.red[400]
    },
    rootWarning: {
        borderColor: theme_1.colors.yellow[300]
    },
    rootSuccess: {
        borderColor: theme_1.colors.green[300]
    }
}); });
var Banner = function (_a) {
    var message = _a.message, _b = _a.classes, classes = _b === void 0 ? {} : _b, _c = _a.variant, variant = _c === void 0 ? 'info' : _c, _d = _a.iconOverrides, iconOverrides = _d === void 0 ? {} : _d, _e = _a.messageTypography, messageTypography = _e === void 0 ? 'body1' : _e;
    var innerClasses = useStyles();
    var icons = __assign({}, defaultBannerIcons, iconOverrides);
    var Icon = icons[variant];
    var rootClassName = classnames_1.default(innerClasses.root, classes.root, utils_1.getRootVariant(innerClasses, variant), utils_1.getRootVariant(classes, variant));
    var iconContainerInfoClassName = classnames_1.default(innerClasses.iconContainer, classes.iconContainer, utils_1.getIconContainerVariant(innerClasses, variant), utils_1.getIconContainerVariant(classes, variant));
    return (react_1.default.createElement(Box_1.default, { className: rootClassName },
        react_1.default.createElement("div", { className: iconContainerInfoClassName },
            react_1.default.createElement(Icon, { className: classnames_1.default(innerClasses.icon, classes.icon), "aria-hidden": true })),
        react_1.default.createElement("div", { className: classnames_1.default(innerClasses.messageContainer, classes.messageContainer) },
            react_1.default.createElement(Typography_1.default, { variant: messageTypography, className: classes.message }, message))));
};
exports.default = Banner;
